import { type User, useGetUserProfileUserProfileGet } from "kubb";
import { useAuthState } from "../reducers/auth";

export const PROFILE_STALE_TIME = 5 * 60 * 1000;

/**
 * The single shared current-user query. TanStack owns the data, invalidation and
 * refetch — exactly like the company/scheme lists (see useCompany.ts).
 *
 * The query is gated on authentication: an unauthenticated profile fetch 401s,
 * and the axios response interceptor (client.ts) hard-redirects to /auth/login on
 * a 401, so firing it pre-auth would bounce the user out. Login's silentAuth primes
 * the cache imperatively (queryClient.fetchQuery) before flipping `authenticated`,
 * so by the time this activates it is a cache read, not a network round-trip.
 */
export function useProfileQuery() {
  const { authenticated } = useAuthState();
  return useGetUserProfileUserProfileGet(undefined, {
    query: { enabled: authenticated, staleTime: PROFILE_STALE_TIME },
  });
}

export function useProfile(): User | undefined {
  return useProfileQuery().data?.data;
}
